<template>
  <div v-if="loaded">
    <!-- AI聊天组件 -->
    <!--    <AIChat :packageNo="packageNo" @stopPlayHandel="stopPlayHandel"/>-->

    <!-- 顶部区域 -->
    <nav>
      <!-- 健康报告标题 -->
      <!-- <div class="report-title">检测报告</div> -->

      <!-- 报告编号和日期 -->
      <div class="file fx bt">
        <div>报告编号：{{ packageNo }}</div>
        <div>{{ checkDate }}</div>
      </div>
      <div class="horizontal-line"></div>

      <!-- 包裹三个区域的容器，添加背景图 -->
      <div class="data-container">
        <!-- 用户信息 -->
        <div class="user-info-card" v-if="user">
          <div class="user-avatar">
            <img :src="user.head_portrait || ''" alt="用户头像"/>
            <img
                class="gender-icon"
                :src="require(`../assets/sex/${user.gender}.png`)"
                v-if="user.gender === '1' || user.gender === '2'"
                alt="性别"
            />
          </div>
          <div class="user-details">
            <div class="user-name-row">
              <span class="user-name">{{ user.name || "苏大力" }}</span>
              <span class="divider-vertical">|</span>
              <span class="user-age">{{ user.age }}岁</span>
            </div>
            <div class="user-metrics">
              <div class="metric">
                <span class="metric-label">身高</span>
                <span class="metric-value"
                >{{ user.user_height || "178" }}cm</span
                >
              </div>
              <div class="metric">
                <span class="metric-label">体重</span>
                <span class="metric-value"
                >{{ user.user_weight || "90" }}kg</span
                >
              </div>
            </div>
          </div>
        </div>

        <!-- 数据指标 -->
        <div class="data fx" v-if="false">
          <!-- 生命体征 -->
          <div class="indicator-wrapper" @click="signDialog = true">
            <circle-progress
                :value="lifeFeaturePercent"
                unit="%"
                label="超越全国用户"
            />
          </div>
          <div class="indicator-wrapper" @click="vigourDialog = true">
            <circle-progress :value="lifeFeaturePercent" label="身体状况">
              <span style="color: #2976fe; font-size: 32px">{{
                  lifeVigourLevel.text
                }}</span>
            </circle-progress>
          </div>
        </div>
        <!-- <div class="horizontal-line"></div> -->
        <!-- 基础数据 -->
        <!-- <div class="info">
          <ul>
            <li>
              <p>
                <b>身高<span class="unit">cm</span></b>
                <i>{{user.user_height}}</i>
              </p>
            </li>
            <li>
              <p>
                <b>体重<span class="unit">kg</span></b>
                <i>{{user.user_weight}}</i>
              </p>
            </li>
            <li>
              <p>
                <b>BMI<span class="unit"></span></b>
                <i class="bmi-value">{{user.user_bmi}}</i>
              </p>
            </li>
            <li>
              <p>
                <b>体脂率<span class="unit">%</span></b>
                <i class="fat-value">{{user.body_fat_ratio}}</i>
              </p>
            </li>
          </ul>

          <div class="fx">肥胖指数：{{user.body_fat_ratio_str || '正常'}}</div>
        </div> -->
      </div>
      <div class="horizontal-line" v-if="false"></div>
    </nav>
    <!-- 内容区域 -->
    <main>
      <AIInterpret ref="aIInterpretRef" :packageNo="packageNo" @suggestionHandle="suggestionHandle" :rand="rand"
                   :checkcode="checkcode" @goMicroelement="goMicroelement" @goOverview="goOverview"
                   :nutritionTabs="nutritionTabs" @nutrition-item-click="handleNutritionItemClick">
        <!-- <template>
          <div class="chat-button-container">
            <button class="ai-chat-button" @click="toggleChat">
              <span class="primary-text">和AI专家深入交流</span>
              <span class="secondary-text" v-if="isCollapsed"
          >需要一套量化干预方案? 跟我聊聊加分秘诀!</span
        >
            </button>
          </div>
        </template> -->
      </AIInterpret>
      
      <!-- 综合风险提示 -->
      <SectionView title="营养失衡风险" v-if="false">
        <div class="overview-content">
          <ul>
            <!-- 将 li 替换为 div.risk-card 来应用卡片样式 -->
            <template v-if="overviews.length > 0">
              <li
                  v-for="(item, index) in overviews"
                  :key="index"
                  data-type="1"
                  class="risk-card"
              >
                <router-link
                    :to="{
                    path: '/details',
                    query: {
                      code: item.system_code,
                      title: item.item_dict_name,
                      av: item.av,
                      ...query,
                    },
                  }"
                    class="item-content"
                >
                  <div class="content-wrapper">
                    <img
                        class="item-icon"
                        src="../assets/图标-红点@2x.png"
                        alt="图标"
                    />
                    <span class="item-title">{{
                        item.comprehensive_evaluation
                      }}</span>
                  </div>
                  <!-- 直接显示箭头图标 -->

                  <img
                      class="arrow-icon"
                      src="../assets/图标-进入.png"
                      alt="箭头"
                  />
                </router-link>
                <div class="item-description" v-if="item.introduction">
                  <span style="color: #495880">{{ item.introduction }}</span>
                </div>
                <div class="item-divider"></div>
              </li>
            </template>
            <!-- 将 li 替换为 div.risk-card 来应用卡片样式 -->
            <li v-else class="risk-card">
              <div class="item-content">
                <div class="content-wrapper">
                  <img
                      class="item-icon"
                      src="../assets/圆形图标.png"
                      alt="图标"
                  />
                  <span class="item-title">未见异常风险</span>
                </div>
                <!-- 直接显示箭头图标 (虽然这里没有箭头，但保持结构一致性) -->
                <!-- <img class="arrow-icon" src="../assets/more.png" alt="箭头" /> -->
              </div>
            </li>
          </ul>
        </div>
      </SectionView>
      <div style="margin-top: -20px" v-if="false">
        <waterfall-card
            :data="sortedHealthData"
            :warningCount="warningHealthCount"
            :qualifiedCount="qualifiedHealthCount"
            :totalItems="healthData.length"
            title="健康风险提示（脏器指标）"
            @item-click="handleHealthItemClick"
        ></waterfall-card>
      </div>

<!--      <NutritionVitalityCard-->
<!--          :tabsData="nutritionTabs"-->
<!--          @item-click="handleNutritionItemClick"-->
<!--      />-->
<!--      <div class="full-health-info-button-container">-->
<!--        <router-link-->
<!--            class="full-health-info-button"-->
<!--            :to="{ path: '/overview', query }"-->
<!--        >查看身体健康信息-->
<!--        </router-link>-->
<!--      </div>-->

<!--      <div class="item-divider"></div>-->

      <!-- 饮食建议 -->
      <DietCard :useless="diets.useless" :useful="diets.useful" :suggestionData="suggestionData" :userData="user" :packageNo="packageNo"></DietCard>
      <!-- 检测要求和注意事项 -->
      <SectionView class="demand" title="监测要求和注意事项">
        <p>
          1、本设备是一种配合临床报告和个人主诉并进行实质性探测的个性化超高灵敏动态跟踪系统。监测前填写的主诉问答与临床验血报告，会与测试数据产生个性化关联而进行动态跟踪若不填写将会失去动态跟踪功能，因此用户必须认真填写!
        </p>
        <p>
          2、报告中的风险提示项是根据本次监测数据及健康评估的即时结果，按照人体各系统与相关内脏器官之间的关联关系，通过人工智能及大数据分析提示有可能发生某种疾病的趋势，并非代表全部的疾病风险，也并非指目前一定是正在发病的状态;由于设备采用了极高灵敏度的探测和预警功能，因此所及的相关提示，有可能是在临床诊断还未提及的潜在疾病或风险，应针对个人的健康状态，在不同时段进行多次监测，并配合相关临床和专业医生应用多次测试数据的规律做进一步的解析。
        </p>
        <p>
          3、报告中所提供的监测数据反映的是人体实时体质的即时数据，在不同时段的监测数据均会发生变化，这是因为不同时段的睡眠、运动、精神、环境、药物使用等各种因素的影响所致;因此建议用户按照个人健康状况，分隔每日长期进行多次监测，以获取更多数据找出体质变化规律，使其实现更加精准。
        </p>
        <p>
          4、AI 小助手提供的所有信息和建议均基于您的检测数据和公开健康知识库生成，仅作为健康参考，不可作为诊断、治疗的直接依据。如有任何身体不适，请及时咨询专业医生。
        </p>
      </SectionView>
    </main>

    <!-- 解读说明弹窗 -->
    <dialog-view v-model="interpret" class="interpret" title="解读说明">
      <span v-for="(item, index) in levels" :key="index"
      ><i :style="{ background: item.color }"></i>{{ item.str }}</span
      >
    </dialog-view>

    <!-- 生命体征弹窗 -->
    <dialog-view title="超越全国用户" v-model="signDialog">
      表示您的健康状况超越了全国多少百分比的用户。该数值越高，表示您的身体状况相对更好。
    </dialog-view>

    <!-- 生命活力弹窗 -->
    <dialog-view title="身体状况" v-model="vigourDialog">
      是指全身各个内脏组织器官的综合评估结果。<br/>
      <span style="font-weight: bold">健康</span
      >：身体状况处于最佳状态，各项功能运转良好。<br/>
      <span style="font-weight: bold">良好</span
      >：身体状况正常，但仍有提升空间。<br/>
      <span style="font-weight: bold">异常</span
      >：身体状况异常，可能存在不适或功能失调。
    </dialog-view>

    <!-- 新冠评估弹窗 -->
    <dialog-view title="风险说明" v-model="xgDialog">
      营养均衡指标从0到1，数值越高表示营养状态越好。失衡（低于0.3）、正常（0.3-0.7）、优异（高于0.7）。
    </dialog-view>

  </div>
</template>

<script>
import {getReportInfoLoop, getSuggestion} from "@/net/api";
import {getReportLoopItemNutritionAll} from "@/net/api";
import {getReportLoopItem} from "@/net/api";
import SectionView from "@/components/SectionView";
import DietCard from "@/components/DietCard";
import DialogView from "../components/DialogView";
// import GaugeCard from "../components/GaugeCard";
import CircleProgress from "../components/CircleProgress";
import WaterfallCard from "../components/WaterfallCard";
import AIInterpret from "../components/AIInterpret";
import aiChatMixin from "@/mixins/aiChatMixin";
// import AIChat from "../components/AIChat";

export default {
  name: "Home",
  mixins: [aiChatMixin],
  components: {
    SectionView,
    DietCard,
    DialogView,
    CircleProgress,
    WaterfallCard,
    AIInterpret
  },

  data() {
    return {
      // 报告编号
      packageNo: "",
      rand: 1639045914,
      checkcode: "997b294a81f5643ec12c37dbfe07d26e",
      userHasInteracted: false,
      awaitingUserGesture: false,
      suggestionData: [],
      // 用户信息
      user: {
        name: "",
        age: "",
        gender: "1",
        birthday: "",
        body_fat_ratio: "0.00",
        body_fat_ratio_str: "",
        head_portrait: "",
        life_feature: "...",
        life_vigour: "...",
        life_vigour_percent: 100,
        report_mark_symbol: 0,
        user_bmi: "0.00",
        user_height: "0.00",
        user_weight: "0.00",
      },
      healthData: [],

      // 可能受影响的器官列表
      affectedOrgans: [],

      // 检测时间
      checkDate: "",

      // 新冠风险提示
      xg_data: null,
      // 综合风险
      overviews: [],
      // 不耐受食物
      diets: {
        useful: [],
        useless: [],
      },
      // 健康状态
      states: [],
      // 检测报告
      reports: [],
      // 报告等级列表
      levels: [],

      // 身体综合检测动态图
      dynamics: [],

      stackValueKey: {
        one: "初值",
        two: "终值",
      },
      avValueKey: {
        av: "均值",
      },

      // 当前选中的健康状态
      state: 0,

      // 解读说明弹窗
      interpret: false,
      // 生命体征弹窗
      signDialog: false,
      // 生命活力弹窗
      vigourDialog: false,
      // 新冠评估弹窗
      xgDialog: false,

      // 当前数据是否加载完成
      loaded: false,

      // 营养素状态
      nutritionStatus: [],
      // 营养素列表 - 确保有一个默认值
      nutritionList: [
        {
          item_dict_name: "加载中...",
          system_code: "",
          av: "...",
        },
      ],
      nutritionTabs: [
        {
          name: "维生素",
          warningCount: 0,
          qualifiedCount: 0,
          items: [],
        },
        // {
        //   name: "微量元素",
        //   warningCount: 0,
        //   qualifiedCount: 0,
        //   items: [],
        // },
        // {
        //   name: "矿物质",
        //   warningCount: 0,
        //   qualifiedCount: 0,
        //   items: [],
        // },
      ],
      // 列表关联项
      columns: {
        item_dict_name: "检测项目",
        av: "均值(-4~+4)",
      },
      audioContext: null,
      audioQueue: null,
      // 先新增一个数组缓存 AudioBuffer，和一个累积长度限制（秒）
      audioBufferCache: [], // 缓存的 AudioBuffer 列表
      // audioBase64Queue = [],
      // isDecoding = false,
      cacheDurationLimit: 0.1, // 1秒为合并阈值，自己调节
      i: 0,
    };
  },

  computed: {
    stateImage() {
      return this.states.length > 0
          ? this.states[this.state].image_url_big
          : null;
    },
    // 生命营养状态
    healthDataFromStates() {
      if (!this.states || this.states.length === 0) {
        return [];
      }

      return this.states.map((item) => ({
        name: item.item_dict_name || "",
        value: parseFloat(item.av) || 0,
      }));
    },
    sortedHealthData() {
      // 复制数组以避免修改原始数据
      return [...this.healthData];
    },

    // 计算警告数量（小于0的项目）
    warningHealthCount() {
      return this.healthData.filter((item) => item.value < 0).length;
    },

    // 计算合格数量（大于等于0的项目）
    qualifiedHealthCount() {
      return this.healthData.filter((item) => item.value >= 0).length;
    },

    // 生命体征百分比转换
    lifeFeaturePercent() {
      // 如果user对象不存在或还未加载数据或者值不是数字，返回0
      if (
          !this.user ||
          this.user.life_feature === "..." ||
          isNaN(Number(this.user.life_feature))
      ) {
        return 0;
      }

      // 将 -4 到 +4 的范围转换为 0-100 的百分比
      const value = Number(this.user.life_feature);
      const percent = Math.round(((value + 4.5) / 8) * 100);
      // 确保百分比在 0-100 范围内
      return Math.max(0, Math.min(100, percent));
    },

    // 生命活力等级判断
    lifeVigourLevel() {
      // 直接使用lifeFeaturePercent计算结果
      const percent = this.lifeFeaturePercent;

      // 根据百分比划分三个等级，但统一使用相同的颜色类名
      if (percent >= 70) {
        return {text: "健康", color: "health"};
      } else if (percent >= 40) {
        return {text: "良好", color: "health"};
      } else {
        return {text: "良好", color: "health"};
      }
    },

    // 生命活力等级对应的颜色
    vigourLevelColor() {
      switch (this.lifeVigourLevel.color) {
        case "health":
          return ["#2ECC71", "#27ae60"];
        case "good":
          return ["#FFFFB5", "#D4B400"];
        case "abnormal":
          return ["#E74C3C", "#c0392b"];
        default:
          return ["#FFFFB5", "#D4B400"];
      }
    },

    // 基础参数数据
    query() {
      return {
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      };
    },

    // 用户基础信息
    basicLabel() {
      const {age} = this.user;
      return age ? age + "岁" : "";
    },

    // 动态计算文字长度
    smallUserName() {
      const maxWidth = window.innerWidth * 0.86;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      ctx.font =
          "normal bold " +
          40 / (750 / window.innerWidth) +
          "px PingFangSC-Semibold, PingFang SC ";
      let width = ctx.measureText(this.user.name).width;
      return width > maxWidth ? "small" : "";
    },
  },

  // GaugeCard  ,添加圆环时候 要加上计算长度

  created() {
    // 优先从URL查询参数获取
    const query = this.$router.currentRoute.query;
    this.packageNo = query.packageNo || "113222";
    this.checkcode = query.checkcode || "2ec86765c49bdec4d65acdb41dc322c7";
    this.rand = query.rand || "1751285166";

    // 重置 AI 状态（新报告开始时）
    this.resetAIState();
    this.$store.commit("SetPackageNo", {
      packageNo: query.packageNo,
    });

    // 设置初始加载状态
    this.keyResultsLoading = true;

    console.log("报告参数:", {
      packageNo: this.packageNo,
      checkcode: this.checkcode,
      rand: this.rand,
    });

    this.syncPageData();
  },

  mounted() {
    // 检查是否支持Web Audio API
    // if (window.AudioContext || window.webkitAudioContext) {
    //   // 初始化音频上下文，提前准备好音频环境
    //   this.initAudioContext();
    //   // 确保页面加载后自动播放音频 (设置标志位为true)
    //   this.soundOn = true;
    // } else {
    //   console.warn("当前浏览器不支持Web Audio API，音频功能将不可用");
    //   this.soundOn = false;
    // }
  },

  methods: {
    // 打开监测结果详情
    goMicroelement(){
      this.$router.push({
        path: "/microelement",
        query: {
          nutritionTabs:this.nutritionTabs,
          queryParams:this.query
        }
      });
    },
    // 打开身体体质详情
    goOverview(){
      this.$router.push({
        path: "/overview",
        query: this.query
      });
    },
    // 打开语音小助手，关闭音频
    stopPlayHandel() {
      console.log('home9999')
      this.$refs.aIInterpretRef.stopPlay()
    },
    // 同步页面数据
    syncPageData() {
      // 获取报告数据
      getReportInfoLoop({
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      })
          .then((data) => {
            this.levels = data.colorData;
            // 安全地设置用户数据，如果userData为空则保持原有数据
            if (data.userData) {
              this.user = data.userData;
            } else {
              console.warn('userData为空，保持原有用户数据');
            }
            this.checkDate = data.checkDate;
            this.overviews = data.comprehensiveRisk;
            this.fetchOverviewsIntroduction();
            this.states = data.show_jiankangzhaungtaitu;
            this.reports = data.show_jiancebaogao;
            this.dynamics = data.show_shentizonghejiancedongtaitu;
            this.xg_data = data.xg_data;
            // 从 states 数据中提取健康数据
            if (this.states && this.states.length > 0) {
              this.healthData = this.states.map((item) => ({
                code: item.system_code || "",
                name: item.item_dict_name || "",
                value: parseFloat(item.av) || 0,
              }));
              // 不再调用updateAffectedOrgans方法
            }

            // 始终调用fetchNutritionData来获取营养素数据，而不依赖getReportInfoLoop返回的数据
            this.fetchNutritionData();

            // 在基础数据加载后获取AI解读
            // this.fetchAIInterpretData();
          })
          .catch((err) => {
            console.error("获取报告数据出错:", err);
            this.loaded = true;
            // 即使发生错误，也尝试获取AI解读
            // this.fetchAIInterpretData();
          });
    },

    // 处理健康指标项点击
    handleHealthItemClick(item) {
      console.log("健康指标点击:", item);
      // 查找对应的原始数据项，获取system_code

      this.$router.push({
        path: "/details",
        query: {
          code: item.code || "",
          title: item.name,
          av: item.value || "",
          ...this.query,
        },
      });
    },
    handleNutritionItemClick(item) {
      this.$router.push({
        path: "/nutrition",
        query: {
          code: item.code || "",
          title: item.name,
          av: item.av || "",
          ...this.query,
        },
      });
    },

    // 获取营养素数据
    fetchNutritionData() {
      getReportLoopItemNutritionAll({
        packageNo: this.packageNo,
        rand: this.rand,
        checkcode: this.checkcode,
      })
          .then((data) => {
            console.log("营养素数据:", data);
            this.nutritionStatus = data.show_zhuangtaitu || [];
            this.nutritionList = data.show_xiangxishuju || [];
            this.processNutritionData();

            // 获取营养素数据后更新受影响的器官
            // this.updateAffectedOrgans();

            console.log(this.nutritionList);

            this.loaded = true;
          })
          .catch((err) => {
            console.error("获取营养素数据出错:", err);
            this.loaded = true;
          });
    },

    processNutritionData() {
      if (!this.nutritionList || this.nutritionList.length === 0) return;

      // 假设前10个是维生素，接下来8个是微量元素，剩余的是矿物质
      // const vitamins = this.nutritionList.slice(0, 10);
      // const microelements = this.nutritionList.slice(10, 17);
      // const minerals = this.nutritionList.slice(17, 26);

      // 转换数据格式
      const convertToTabFormat = (items) => {
        return items.map((item) => {
          // 假设item.av是一个-4到+4的值
          const value = parseFloat(item.av) || 0;
          return {
            name: item.item_dict_name,
            value: value,
            nameEn: item.item_dict_name_en,
            code: item.system_code,
            av: item.av,
          };
        });
      };

      // 计算预警和合格项目数量
      const countWarningAndQualified = (items) => {
        let warningCount = 0;
        let qualifiedCount = 0;

        items.forEach((item) => {
          const value = parseFloat(item.av) || 0;
          if (value < 0) {
            warningCount++;
          } else {
            // 其他为合格项目
            qualifiedCount++;
          }
        });

        return {warningCount, qualifiedCount};
      };

      // 更新维生素标签页
      console.log(this.nutritionList);
      const stats = countWarningAndQualified(this.nutritionList);
      this.nutritionTabs[0].items = convertToTabFormat(this.nutritionList);
      this.nutritionTabs[0].warningCount = stats.warningCount;
      this.nutritionTabs[0].qualifiedCount = stats.qualifiedCount;

      // 更新维生素标签页
      // const vitaminStats = countWarningAndQualified(vitamins);
      // this.nutritionTabs[0].items = convertToTabFormat(vitamins)
      // this.nutritionTabs[0].warningCount = vitaminStats.warningCount;
      // this.nutritionTabs[0].qualifiedCount = vitaminStats.qualifiedCount;

      // 更新微量元素标签页
      // const microStats = countWarningAndQualified(microelements);
      // this.nutritionTabs[2].items = convertToTabFormat(microelements);
      // this.nutritionTabs[2].warningCount = microStats.warningCount;
      // this.nutritionTabs[2].qualifiedCount = microStats.qualifiedCount;
      //
      // // 更新矿物质标签页
      // const mineralStats = countWarningAndQualified(minerals);
      // this.nutritionTabs[1].items = convertToTabFormat(minerals);
      // this.nutritionTabs[1].warningCount = mineralStats.warningCount;
      // this.nutritionTabs[1].qualifiedCount = mineralStats.qualifiedCount;

      console.log("处理后的营养标签页数据:", this.nutritionTabs);
    },

    // 获取每个健康指标的详细介绍
    fetchOverviewsIntroduction() {
      if (!this.overviews || this.overviews.length === 0) return;

      // 为每个健康指标获取介绍信息
      this.overviews.forEach((item, index) => {
        getReportLoopItem({
          packageNo: this.packageNo,
          rand: this.rand,
          checkcode: this.checkcode,
          system_code: item.system_code,
        }).then((data) => {
          // 使用Vue的$set方法确保响应式更新
          this.$set(
              this.overviews[index],
              "introduction",
              data.show_liuduan !== "未见异常风险" ? data.show_liuduan : ""
          );
          this.diets.useful = data.show_yinshijianyi.tolerantFood || [];
          this.diets.useless = data.show_yinshijianyi.noTolerantFood || [];
        });
      });
    },

    // 导航到概览页面
    navigateToOverview(code) {
      if (!code) {
        console.error("导航错误：缺少code参数");
        return;
      }

      this.$router.push({
        path: "/overview",
        query: {
          code: code,
          ...this.query,
        },
      });
    },
    // 调用AIChat组件的打开聊天功能
    // toggleChat() {
    //   // 查找AIChat组件实例
    //   const aiChatComponent = this.$children.find(
    //     (child) => child.$options.name === "AIChat"
    //   );
    //   if (aiChatComponent) {
    //     aiChatComponent.toggleChat();
    //   }
    // },
    // 获取解读建议
    async suggestionHandle() {
      const res = await getSuggestion({serial_number: this.packageNo})
      if (res) {
        this.suggestionData = res
      }
    }

  },
};
</script>

<style lang="scss" scoped>
/* 顶部 */
nav {
  // position: relative;
  //height: 700px;
  /* 使用背景图片实现渐变效果 */
  // background-image: url("../assets/bg.png");
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  padding: 30px;
  color: #0f0707;
  box-sizing: border-box;

  /* 健康报告标题 */
  .report-title {
    font-size: 44px;
    font-weight: 600;
    text-align: center;
    margin-top: 62px;
    margin-bottom: 9px;
    letter-spacing: 2px;
  }

  /* 报告编号和日期 */
  .file {
    font-size: 24px;
    padding-left: 8rpx;
    padding-right: 8rpx;
    color: rgba(47, 41, 41, 0.7);

    div {
      height: 36px;
    }
  }

  .horizontal-line {
    margin-bottom: 40px;
    border-bottom: 1px solid #cccccc;
    width: 100%;
  }

  /* 用户信息卡片样式 */
  .user-info-card {
    display: flex;
    align-items: center;
    border-radius: 15px;
    padding: 15px;
    margin: 20px 0;

    .user-avatar {
      position: relative;
      display: flex;
      width: 115px;
      height: 115px;
      border-radius: 50%;
      margin-right: 30px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 50%;
      }

      .gender-icon {
        position: absolute; /* 绝对定位 */
        bottom: 0;
        right: -10px;
        width: 36px; /* 设置大小 */
        height: 36px; /* 设置大小 */
        border-radius: 50%; /* 圆形 */
        padding: 2px; /* 内边距 */
        z-index: 10; /* 确保在上层 */
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2); /* 添加阴影 */
      }
    }

    .user-details {
      flex: 1;

      .user-name-row {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .user-name {
          font-size: 32px;
          font-weight: 600;
          color: #00133d;
          margin-right: 15px;
        }

        .divider-vertical {
          color: #ced8e3;
          margin: 0 15px;
          font-weight: 300;
          font-size: 32px;
        }

        .user-age {
          font-size: 26px;
          color: #00133d;
        }
      }

      .user-metrics {
        display: flex;

        .metric {
          display: flex;
          align-items: center;
          margin-right: 20px;

          .metric-label {
            font-size: 24px;
            color: #00133d;
            margin-right: 8px;
          }

          .metric-value {
            font-size: 24px;
            color: #00133d;
            font-weight: 500;
          }
        }
      }
    }
  }

  /* 包裹三个区域的容器，添加背景图 */
  .data-container {
    position: relative;
    padding: 10px 15px;
    margin: 0 -15px;
    margin-top: -30px;
    margin-bottom: 25px;
    // background-image: url("../assets/bg-01.png");
    // background-repeat: no-repeat;
    // background-size: 100% 100%;

    /* 用户信息 */
    .user {
      height: 120px;
      display: flex;
      justify-content: center;
      align-items: center;

      .user-row {
        display: flex;
        align-items: center;
        height: 65px;
        background-color: #eaf3ff;
        border-radius: 80px;
        padding: 0 50px;
      }

      .user-name-container {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .user-name {
        font-size: 30px;
        font-weight: 500;
        color: #1a1a1a;
      }

      .gender-icon {
        width: 33px;
        height: 33px;
        margin-left: 10px;
      }

      .divider {
        width: 1px;
        height: 27px;
        background-color: #b5c7f7;
        margin: 0 30px;
      }

      .user-age {
        font-size: 26px;
        font-weight: 400;
        color: #131111;
      }

      b,
      span {
        display: none;
      }
    }

    /* 数据指标 */
    .data {
      display: flex;
      justify-content: center;
      padding-top: 10px;
      margin-bottom: 20px;
      box-shadow: none;

      .indicator-wrapper {
        position: relative;
        width: 280px;
        height: 280px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: transparent;
        box-shadow: none;

        &:last-child {
          margin-left: 70px;
        }
      }
    }

    /* 基础数据 */
    // .info {
    //   display: flex;
    //   height: 230px;
    //   overflow: hidden;
    //   flex-direction: column;
    //   margin-top: 24px;
    //   color: #000000;

    //   ul {
    //     flex: 1;
    //     padding: 0 12px;

    //     li {
    //       position: relative;
    //       flex: 1;
    //       display: flex;
    //       align-items: center;
    //       justify-content: center;
    //       font-size: 28px;
    //       color: #000000;

    //       &:after {
    //         position: absolute;
    //         content: "";
    //         display: block;
    //         width: 1px;
    //         height: 40px;
    //         background: #C7C7C7;
    //         border-radius: 1px;
    //         right: 0;
    //       }

    //       &:last-child {
    //         &:after {
    //           display: none;
    //         }
    //       }

    //       p {
    //         display: flex;
    //         flex-direction: column;
    //         align-items: flex-start;
    //       }

    //       b {
    //         font-weight: 400;
    //         font-size: 26px;
    //         color: #000000;

    //         .unit {
    //           font-size: 25px;
    //           margin-left: 4px;
    //           font-weight: normal;
    //           color: #999999;
    //         }
    //       }

    //       i {
    //         padding-top: 10px;
    //         color: #333333;
    //         font-weight: 500;
    //         font-family: AccidentalPresidency;
    //         font-size: 38px;

    //         &.bmi-value {
    //           color: #FF5C4D;
    //         }

    //         &.fat-value {
    //           color: #FD9243;
    //         }
    //       }
    //     }
    //   }

    //   div {
    //     font-size: 26px;
    //     height: 100px;
    //     color: #000000;
    //   }
    // }
  }
}

/* 内容 */
main {
  margin-top: -60px;
  padding: 10px 15px;

  .link {
    display: block;
    text-decoration: none;
    height: 80px;
    border-radius: 20px;
    font-size: 32px;
    color: #6ca0ec;
    line-height: 80px;
    padding: 0 30px;
    background-color: #edf4ff;
    background-image: url("../assets/more.png");
    background-repeat: no-repeat;
    background-position: right 30px center;
    background-size: 40px 40px;
  }

  .overview {
    background-color: #ffffff;
    min-height: 256px;
    padding: 15px 0;
    margin: 10px 0;

    ul {
      flex-direction: column;
      align-items: flex-start;
      padding-left: 20px;
      padding-top: 15px;
      padding-right: 20px;

      li {
        position: relative;
        margin-bottom: 12px;
        display: flex;
        flex-direction: column;
        width: 100%;
        border-bottom: 1px solid #eaeaea;
        padding-bottom: 8px;
      }

      /* 移除 item-number 样式 */
      /* .item-number { ... } */

      /* 添加 item-icon 样式 */
      .item-icon {
        width: 36px; /* 根据需要调整大小 */
        height: 36px; /* 根据需要调整大小 */
        margin-right: 12px; /* 调整与标题的间距 */
        flex-shrink: 0;
        vertical-align: middle; /* 尝试垂直居中 */
      }

      .item-content {
        position: relative;
        z-index: 1;
        text-decoration: none;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
        padding-top: 8px;
        min-height: 40px;
        padding-bottom: 0;
      }

      .content-wrapper {
        display: flex;
        align-items: center; /* 让图标和文字垂直居中 */
        flex: 1;
      }

      .item-title {
        flex: 1;
        font-size: 30px;
        font-weight: 900;
        line-height: 1.3;
      }

      .item-description {
        font-size: 24px;
        color: #495880;
        line-height: 1.5;
        margin-top: 8px;
        margin-left: 0;
        padding-left: 0;
        margin-right: 0;
        text-align: justify;
        padding-bottom: 10px;
        padding-top: 0;
        width: 100%;
        box-sizing: border-box;
      }

      .arrow-icon {
        width: 40px;
        height: 40px;
        margin-left: auto;
        margin-right: 8px;
        margin-top: 2px;
        object-fit: contain;
        filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.1));
        flex-shrink: 0;
      }
    }
  }

  .overview-content {
    min-height: auto; /* 重置最小高度 */

    ul {
      flex-direction: column;
      align-items: stretch; /* 让列表项撑满宽度 */
      padding: 0 3px; /* 调整左右内边距 */

      /* 应用卡片样式 */
      .risk-card {
        position: relative;
        display: flex; /* 使用 flex 布局 */
        flex-direction: column;
        width: 100%;
        // background-color: #F8FCFF;
        border-radius: 20px; /* 圆角 */
        padding-bottom: 10px;
        padding-right: 20px;
        // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); /* 调整阴影 */
        box-sizing: border-box; /* 确保 padding 不会撑大元素 */
      }

      /* 调整图标样式 - 匹配目标图片 */
      .item-icon {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        flex-shrink: 0;
        vertical-align: middle;
      }

      .item-content {
        position: relative;
        color: #333333;
        z-index: 1;
        text-decoration: none;
        display: flex;
        justify-content: space-between;
        align-items: center; /* 垂直居中对齐 */
        width: 100%;
      }

      .content-wrapper {
        display: flex;
        align-items: center;
        flex: 1;
        margin-right: 10px;
      }

      .item-title {
        flex: 1;
        font-size: 28px;
        font-weight: 600;
        line-height: 1.3;
        color: #333;
      }

      .item-description {
        font-size: 24px;
        color: #666666;
        line-height: 1.4;
        margin-top: 20px;
        padding-left: 42px;
        text-align: justify;
        width: 100%;
        box-sizing: border-box;
      }

      /* 调整箭头图标样式 - 匹配目标图片 */
      .arrow-icon {
        width: 40px; /* 增大箭头图标大小 */
        height: 40px; /* 增大箭头图标大小 */
        flex-shrink: 0; /* 防止被压缩 */
      }
    }
  }

  /* 健康状态图 */
  .state {
    .preview {
      position: absolute;
      width: 100%;
      top: 50px;
      bottom: 0;

      img {
        max-height: 616px;
      }
    }

    ul {
      position: relative;
      height: 626px;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: space-between;
      z-index: 1;

      li {
        width: 170px;
        height: 60px;
        border-radius: 10px;
        border: 1px solid #979797;
        display: flex;
        align-items: center;
        padding-left: 14px;
        margin: 9px 0;
        flex-shrink: 0;
        box-sizing: border-box;
        color: #333333;

        &.active {
          background: #2262b1;
          border: 1px solid #2262b1;
          color: #ffffff;
        }

        i {
          width: 30px;
          height: 30px;
          border-radius: 10px;
        }

        span {
          font-size: 26px;
          padding-left: 6px;
        }
      }
    }
  }

  /* 检测报告 */
  .report {
    ul {
      li {
        width: 58px;
        height: 100%;
        border-left: 2px solid #ffffff;

        &:first-child {
          flex: 1;
          border-left: none;
        }

        &:last-child {
          width: 66px;
        }
      }
    }

    .header {
      height: 316px;
      background: #2262b1;
      border-radius: 10px;
      font-size: 32px;
      color: #ffffff;

      li {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;

        i {
          width: 30px;
          height: 30px;
          border-radius: 10px;
          margin-bottom: 10px;
        }

        span {
          width: 30px;
          line-height: 36px;
        }
      }

      .item {
        font-size: 30px;
        line-height: 36px;
      }
    }

    .body {
      height: 80px;
      background: #f5f6f9;
      border-radius: 10px;
      margin-top: 10px;

      &:nth-child(2n) {
        background: #e0edff;
      }

      li {
        height: 100%;
        display: flex;
        font-size: 32px;
        color: #333333;
        align-items: center;

        img {
          width: 40px;
          height: 40px;
          object-fit: cover;
          margin: 0 10px 0 12px;
        }

        i {
          width: 30px;
          height: 30px;
          border-radius: 10px;
          margin: 0 auto;
        }

        .more {
          width: 40px;
          height: 40px;
          border-radius: 0;
          margin: 0 auto;
          background: url("../assets/more.png") no-repeat;
          background-size: 40px 40px;
        }
      }
    }
  }

  /* 检测要求和注意事项 */
  .demand {
    padding-bottom: 70px;

    p {
      font-size: 22px; /* 调小字号 */
      color: #959FB7; /* 设置为灰色 */
      line-height: 36px; /* 相应调整行高 */
      margin-top: 30px; /* 调整上边距 */
      text-align: justify;
      margin-left: 20px;

      &:first-child {
        margin-top: 0;
      }
    }
  }
}

.item-divider {
  width: 100%;
  height: 1px;
  border-top: 2px dashed #dfdfdf; /* 将实线背景改为虚线边框 */
  background-color: transparent; /* 移除背景色 */
  margin: 25px 0;
}

.full-health-info-button-container {
  padding: 20px 30px;
  margin: 20px 0;
}

.full-health-info-button {
  width: 100%;
  height: 90px;
  background-color: #003cbf;
  color: #ffffff;
  border: none;
  border-radius: 45px;
  font-size: 27px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  cursor: pointer;
}

</style>
